import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment'
import {CacheService } from '../_helpers/cacheService.service';


@Injectable({
  providedIn: 'root'
})
export class MainServiceService {
  apiUrl: string;
  // apiUrl = "http://202.51.74.20/dbapi/DashBoard";
  // apiUrl = "http://localhost:5000";


  

  constructor( private http: HttpClient,
    private router: Router,
    private cacheService:CacheService) { 
    
    }


    masterGetMethod(url){
      let res = { status: "error", result: "" };
      let returnSubject: Subject<any> = new Subject();
    // const options = { headers: this.getRequestOption(), method: "get" };

      this.http.get(`${environment.apiUrl}${url}`).subscribe(
        (data)=>{
          if(data['status']=="ok"){
            res.status ="ok";
            res.result = data["result"];
            returnSubject.next(res);
          returnSubject.unsubscribe();
          }else{
            res.status = "error";
          res.result = data["result"];
          returnSubject.next(res);
          returnSubject.unsubscribe();
          }
        },
        (error)=> {
          (res.status = "error2"), (res.result = error);
        returnSubject.next(res);
        returnSubject.unsubscribe();
        }
      );
      return returnSubject;
    }

    getCompanyList(){
      return this.http.get(environment.apiUrl + '/Company/getCompany');
    }

    postCompanyWise(data){
      return this.http.post(environment.apiUrl + '/api/CompanywiseSales',data);
    }

    getUserProfile(){
      if(!this.cacheService.exist('user')){
        return null;
      }
      let userProfile = this.cacheService.get('user');
      return userProfile;
    }

    getUserSetting(){
      if(!this.cacheService.exist('dashboardSettings')){
        return null;
      }
      let userSettings = this.cacheService.get('dashboardSettings');
      return userSettings;
    }

    
}
